import PropTypes from 'prop-types';
import React from 'react';
import PureComponent from '../pure';

import Select from '../formElements/Select';

import sAction from 'sAction';

class ListViewLooks extends PureComponent {
    selectLook(e) {
        const prefix = this.props.prefix;
        const value = e.target.value;
        if (prefix == 'view') {
            localStorage.setItem(this.props.module+'_saved_search', value);
        }
        sAction.selectLook(e.target.value, prefix);
        this.clearSearchContext();
    }

    clearSearchContext() {
        const prefix = this.props.prefix;
        const module = sAction.dataGet(prefix + '/modul');
        const view = this.props.prefix.split('/').slice(-1)[0];
        const searchContext = sAction.getStorage('searchContext');

        if (searchContext && searchContext[`${module}_${view}`]) {
            searchContext[`${module}_${view}`] = {
                searchData: [],
            };
        }
        sAction.setStorage('searchContext', searchContext);
    }

    copyViewLink(currentView) {
        const viewUrl = window.location.href.split('?')[0] + '?view=' + currentView;
        // copy to clipboard
        navigator.clipboard.writeText(viewUrl);
        // show message
        sAction.toast({name: sAction.translate('LBL_VIEW_LINK_COPIED'), description: ' '});
    }

    render() {
        const data = this.props.data;
        const options = [
            {value: ' ', label: sAction.translate('LBL_ALL')},
        ];
        const assignedUser = sAction.dataGet('conf/user/id');// pokud jej ziskam tady, tak rozhodne i na BE
        if (this.props.hasAssignedUser || assignedUser) {
            options.push({value: 'only_my', label: sAction.translate('LBL_ONLY_MY')});
        }
        //  options.push({value:"All",label:sAction.translate("LBL_LIST_LOOKS_ALL")})
        if (data != undefined) {
            data.forEach((element) => {
                options.push({value: element.get('id'), label: element.get('name')});
            });
        }
        let defValue = ' ';
        if ( this.props.prefix == 'view') {
            const lsVal = localStorage.getItem(this.props.module+'_saved_search');
            if (lsVal) {
                defValue = lsVal;
            }
        } else if (this.props.actSavedSearch) {
            defValue = this.props.actSavedSearch;
        }
        const select = (
            <Select
                value={defValue}
                containerClassName="withBorder"
                key={window.location.hash}
                options={options}
                onChange={(e) => this.selectLook(e)}
            />
        );

        return (
            <div className="listViewLooksContainer ">
                <div className="listViewLooksLabel">
                    {sAction.translate('LBL_LIST_LOOKS')}:
                </div>
                <div className="listViewLooksContent">{select}</div>
                {(defValue && defValue.trim().length > 0 && defValue !== 'only_my') &&
                    <div className="copyViewLinkBtn" onClick={() => this.copyViewLink(defValue)}>
                        <span className="iconfas-link" />
                    </div>
                }
            </div>
        );
    }
}

ListViewLooks.propTypes = {
    actSavedSearch: PropTypes.any,
    data: PropTypes.any,
    hasAssignedUser: PropTypes.any,
    module: PropTypes.string,
    prefix: PropTypes.string,
};
export default ListViewLooks;
